import React from 'react';
import './global';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from '@locale';
import { Provider } from 'react-redux';
import { configureStore } from '@redux/store';
import * as serviceWorker from './serviceWorker';
import App from './App';

function removeConsole() { }

if (!isDev) {
  console.log = removeConsole;
  console.warn = removeConsole;
  console.error = removeConsole;
}

ReactDOM.render(
  <Provider store={configureStore()}>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
